/**
 * Site Backend Query API
 * # Summary Elisa B2B Online Sitebackend query-API written in golang hosted in AWS cloud  # Usage This API is used in the `https://yrityksille.elisa.fi/` pages.  # Identifiers 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IdeatHomepageLink } from './ideatHomepageLink.js';


/**
 * Configuration for the Ideat landing page, sourced from Contentful articleHomePageConfiguration.
 */
export interface IdeatHomepageConfigResponse { 
    /**
     * Navigation links shown below the hero on the landing page, resolved from the linkCollection field.
     */
    links: Array<IdeatHomepageLink>;
    /**
     * Whether to append a \'Kaikki aihetunnisteet\' link after the collection links.
     */
    displayAllKeywordsLink: boolean;
    /**
     * Gradient overlay color for the hero section.
     */
    heroGradientColor?: IdeatHomepageConfigResponse.HeroGradientColorEnum;
    /**
     * Meta title for the landing page.
     */
    metaTitle: string;
    /**
     * Meta description for the landing page.
     */
    metaDescription: string;
    /**
     * Open Graph image URL for social sharing.
     */
    openGraphImageUrl?: string;
    /**
     * Alt text for the Open Graph image.
     */
    openGraphImageAltText?: string;
}
export namespace IdeatHomepageConfigResponse {
    export type HeroGradientColorEnum = 'black' | 'blue' | 'blue-200' | 'blue-400' | 'blue-600' | 'blue-800';
    export const HeroGradientColorEnum = {
        black: 'black' as HeroGradientColorEnum,
        blue: 'blue' as HeroGradientColorEnum,
        blue_200: 'blue-200' as HeroGradientColorEnum,
        blue_400: 'blue-400' as HeroGradientColorEnum,
        blue_600: 'blue-600' as HeroGradientColorEnum,
        blue_800: 'blue-800' as HeroGradientColorEnum
    };
}


